import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function AdminMobileBottomNav() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const navItems = [
    { name: "Dashboard", path: "/admin/dashboard", icon: "📊" },
    { name: "Produk", path: "/admin/products", icon: "🛍️" },
    { name: "Slider", path: "/admin/sliders", icon: "🖼️" },
    { name: "Invoice", path: "/admin/invoices", icon: "📄" },
    { name: "Setting", path: "/admin/settings", icon: "⚙️" },
  ];

  return (
    <nav className="admin-mobile-nav">
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`admin-mobile-nav-item ${isActive(item.path) ? "active" : ""}`}
        >
          <span className="admin-mobile-nav-icon">{item.icon}</span>
          <span className="admin-mobile-nav-label">{item.name}</span>
        </Link>
      ))}
    </nav>
  );
}
